import { createMultiStyleConfigHelpers as d } from "@chakra-ui/react";
import { ThemeColorToken as o, ThemeRadiusToken as a, ThemeFontToken as r, ThemeFontSizeToken as n } from "../theme-tokens.js";
import { buttonConfig as t } from "./button-theme.js";
import { modalAnatomy as m } from "../../../packages/casper-ui-library/node_modules/@chakra-ui/anatomy/dist/esm/components.js";
const { definePartsStyle: e, defineMultiStyleConfig: l } = d(m.keys);
var i;
const x = e({
  overlay: {
    // Non white label-overridable color based on black, always
    bg: "rgba(0, 0, 0, 0.32)"
  },
  header: {
    bg: o.Surface,
    position: "relative",
    fontSize: n.XLarge,
    fontFamily: r.SubHeader,
    color: o.OnSurfaceHeader,
    fontWeight: "medium",
    borderTopRadius: a.Large,
    minHeight: "72px",
    px: 0,
    py: 0
  },
  body: {
    borderTopRadius: a.Large,
    fontFamily: r.Body,
    px: 0,
    py: 0
  },
  dialog: {
    maxW: "384px",
    my: "48px",
    borderRadius: a.Large,
    bg: o.Surface,
    color: o.OnSurface
  },
  dialogContainer: {
    height: "100dvh"
  },
  footer: {
    borderBottomRadius: a.Large,
    bg: o.Surface,
    px: 0,
    py: 0
  },
  closeButton: {
    width: "40px",
    minW: "40px",
    maxW: "40px",
    height: "40px",
    minH: "40px",
    maxH: "40px",
    position: "relative",
    zIndex: "0",
    right: "unset",
    top: "unset",
    alignSelf: "flex-start",
    ...t.baseStyle,
    ...(i = t.variants) == null ? void 0 : i.secondary
  }
}), s = {
  sm: e({
    dialog: {
      maxW: "384px"
    }
  }),
  md: e({
    dialog: {
      maxW: "560px",
      mx: "48px"
    }
  }),
  lg: e({
    dialog: {
      maxW: "960px",
      mx: "80px"
    }
  }),
  xl: e({
    dialog: {
      maxW: "100%",
      mx: "80px"
    }
  }),
  full: e({
    dialog: {
      borderRadius: 0
    },
    body: {
      borderRadius: 0
    },
    header: {
      borderRadius: 0
    },
    footer: {
      borderRadius: 0
    }
  })
}, g = {
  /** Custom variant appearing as a mobile app "bottom sheet",
   * filling 100% of view width and max 100% - 88px view height. */
  bottomSheet: e({
    dialog: {
      maxW: "100vw",
      maxHeight: "calc(100dvh - 88px)",
      borderBottomRadius: 0,
      margin: 0
    },
    footer: {
      borderBottomRadius: 0
    },
    dialogContainer: {
      alignItems: "flex-end"
    }
  })
}, h = l({
  baseStyle: x,
  variants: g,
  sizes: s
});
export {
  h as modalConfig
};
